var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompararIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_920_4661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8708 14.5762C5.18895 14.5762 5.44687 14.8341 5.44687 15.1522V23.3247C5.44687 23.6429 5.18895 23.9008 4.8708 23.9008H3.71865C3.40049 23.9008 3.14258 23.6429 3.14258 23.3247V15.1522C3.14258 14.8341 3.40049 14.5762 3.71865 14.5762H4.8708Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76435 10.4319C10.0825 10.4319 10.3404 10.6898 10.3404 11.008V23.3247C10.3404 23.6429 10.0825 23.9008 9.76435 23.9008H8.61221C8.29405 23.9008 8.03613 23.6429 8.03613 23.3247V11.008C8.03613 10.6898 8.29405 10.4319 8.61221 10.4319H9.76435Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6599 12.5039C14.978 12.5039 15.2359 12.7618 15.2359 13.08V23.3246C15.2359 23.6428 14.978 23.9007 14.6599 23.9007H13.5077C13.1896 23.9007 12.9316 23.6428 12.9316 23.3246V13.08C12.9316 12.7618 13.1896 12.5039 13.5077 12.5039H14.6599Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5544 9.39575C19.8725 9.39575 20.1305 9.65367 20.1305 9.97182V23.3247C20.1305 23.6428 19.8725 23.9007 19.5544 23.9007H18.4022C18.0841 23.9007 17.8262 23.6428 17.8262 23.3247V9.97182C17.8262 9.65367 18.0841 9.39575 18.4022 9.39575H19.5544Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2438 3.508C20.2438 3.19042 19.9864 2.93298 19.6688 2.93298H15.6385C15.3209 2.93298 15.0635 2.67553 15.0635 2.35796V1.43586C15.0635 1.11828 15.3209 0.86084 15.6385 0.86084H21.7409C22.0585 0.86084 22.316 1.11828 22.316 1.43586V7.53831C22.316 7.85588 22.0585 8.11333 21.7409 8.11333H20.8188C20.5013 8.11333 20.2438 7.85588 20.2438 7.53831V3.508Z",
    fill: "#143578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9084 1.91839C22.1332 2.14272 22.1336 2.5068 21.9093 2.73159L15.2251 9.42932C15.0003 9.65459 14.6352 9.6544 14.4107 9.42889L10.8958 5.89952C10.6713 5.674 10.3062 5.67381 10.0814 5.89911L3.55654 12.4378C3.33222 12.6626 2.96814 12.663 2.74334 12.4387L2.09062 11.7873C1.86583 11.563 1.86544 11.1989 2.08976 10.9741L10.0828 2.96407C10.3077 2.73877 10.6727 2.73896 10.8973 2.96448L14.4122 6.49392C14.6368 6.71943 15.0018 6.71962 15.2267 6.49434L20.4425 1.26785C20.6669 1.04307 21.031 1.0427 21.2557 1.26703L21.9084 1.91839Z",
    fill: "#143578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_920_4661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.380859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompararIcon);
export default __webpack_public_path__ + "static/media/CompararIcon.1229752ca3d1c6cc31ca4f1636601db2.svg";
export { ForwardRef as ReactComponent };